/* Thousands grouping for number inputs shown as text: the field shows the grouped number
   ("300 000") once left and the raw digits while typed, and the form keeps the raw number, which
   the number validation and the API mappers already understand. Decimals take a comma or a dot. */

const GROUP_SEPARATOR = " ";

/** Raw number string from what the user typed: digits and at most one decimal separator (as a dot). */
export const parseGroupedNumber = (text: string): string => {
  const cleaned = text.replace(/[^\d.,]/g, "").replace(/,/g, ".");
  const [integer, ...decimals] = cleaned.split(".");
  // A lone separator keeps its place while the decimals are being typed ("12," → "12.").
  return decimals.length > 0 ? `${integer}.${decimals.join("")}` : integer;
};

/** Grouped display of a raw number string or number: "1234567.5" → "1 234 567,5". Empty stays empty. */
export const formatGroupedNumber = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  const [integer, decimals] = String(value).split(".");
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, GROUP_SEPARATOR);
  return decimals !== undefined ? `${grouped},${decimals}` : grouped;
};

/** Ungrouped display while the field is being typed: "1234567.5" → "1234567,5". */
export const formatRawNumber = (value: string | number | null | undefined): string =>
  value === null || value === undefined ? "" : String(value).replace(".", ",");
